export default {
  actions: 'acciones',
  action: 'acción',
  entity: 'entidad',
  event: 'evento',
  triggers: 'Automatizaciones',

  title_trigger: 'Automatizaciones',
  new_trigger: 'Nueva Automatización',

  title_integration: 'Integraciones',
  new_integration: 'Nueva Integración',

  modalTitle: 'Nueva automatización',
  modalTitle_edit: 'Editando automatización',
  modalTitle_cloning: 'Clonando automatización',

  when: 'Cuando un(a) ',
  when_male: 'Cuando un ',
  when_female: 'Cuando una ',

  'status.all': 'Todas',
  'status.request': 'Solicitud',
  'status.open': 'Abierta',
  'status.received': 'Recibida',
  'status.accept': 'Aceptada',
  'status.refused': 'Rechazada',
  'status.execution': 'Ejecución',
  'status.pause': 'Pausada',
  'status.unproductive': 'Improductiva',
  'status.completed': 'Completada',
  'status.pending': 'Pendiente',
  'status.canceled': 'Cancelada',
  'status.approved': 'Aprobada',
  'status.disapproved': 'Rechazada',
  'status.resolved': 'Resuelta',
  'status.unresolved': 'No Resuelta',
  'status.actionPlan': 'Plan de Acción',
  'status.request_plural': 'Solicitudes',
  'status.open_plural': 'Abiertas',
  'status.received_plural': 'Recibidas',
  'status.accept_plural': 'Aceptadas',
  'status.refused_plural': 'Rechazadas',
  'status.execution_plural': 'Ejecuciones',
  'status.pause_plural': 'Pausadas',
  'status.unproductive_plural': 'Improductivas',
  'status.completed_plural': 'Completadas',
  'status.pending_plural': 'Pendientes',
  'status.canceled_plural': 'Canceladas',
  'status.approved_plural': 'Aprobadas',
  'status.disapproved_plural': 'Rechazadas',
  'status.resolved_plural': 'Resueltas',
  'status.unresolved_plural': 'No Resueltas',
  'status.actionPlan_plural': 'Planes de Acción',
  'status.done': 'Completadas',
  'status.ignored': 'Ignorada',
  'status.ignored_plural': 'Ignoradas',
  'status.inProgress': 'En progreso',
  'status.inProgress_plural': 'En progreso',
  'status.closing': 'Cierre',
  'status.closing_plural': 'Cierres',
  'status.true': 'Sí',
  'status.false': 'No',

  'relatives.relative_before': ' Antes del(a) ',
  'relatives.relative_moment': 'En el momento exacto del(a) ',
  'relatives.relative_after': ' Después del(a) ',
  'relatives.relative_custom': 'Personalizar ',

  'periods.every_day': 'Cada día',
  'periods.every_week': 'Cada semana',
  'periods.every_month': 'Cada mes',

  'fields.service_order.user_id': 'usuario',
  'fields.group_id': 'grupo responsable de la actividad',
  'fields.user.contract.group_id': 'grupo del usuario responsable',
  'fields.service_order.parent.user_id': 'usuario de la actividad padre',
  'fields.user_id': 'usuario',
  'fields.service_order.opened': 'Actividad abierta',
  'fields.service_order.place_id': 'local',
  'fields.service_order.parent.place_id': 'local de la actividad padre',
  'fields.non_compliance.opened': 'Actividad abierta',
  'fields.non_compliance.place_id': 'local',
  'fields.non_compliance.place.place_level_ids': 'nivel de local',
  'fields.non_compliance_event.place.place_level_ids': 'nivel de local',
  'fields.non_compliance_event.service_order.place_id': 'local',
  'fields.non_compliance_event.non_compliance.place_id': 'local',
  'fields.place_id': 'local',
  'fields.place.place_level_ids': 'nivel de local',
  'fields.place.place_type_id': 'tipo de local',
  'fields.service_order.place.place_level_ids': 'nivel de local',
  'fields.form_id': 'formulario',
  'fields.service_order.checklist_id': 'cuestionario',
  'fields.service_order.parent.checklist_id': 'cuestionario de la actividad padre',
  'fields._event_service_order_reply_value': 'respuesta de la pregunta',
  'fields._form_reply_reply_value': 'respuesta de la pregunta',
  'fields.non_compliance.question.checklist_id': 'cuestionario',
  'fields.non_compliance_event.service_order.checklist_id': 'cuestionario',
  'fields.non_compliance_event.form_reply.form.checklist_id': 'cuestionario',
  'fields.form.checklist_id': 'cuestionario',
  'fields.checklist_id': 'cuestionario',
  'fields.status_id': 'estado',
  'fields.tag_id': 'tag',
  'fields.service_order.tag_id': 'tag',
  'fields.non_compliance.question_id': 'pregunta',
  'fields.non_compliance.question.tag_ids': 'etiqueta de la pregunta',
  'fields.non_compliance_event.non_compliance.question_id': 'pregunta',
  'fields.non_compliance_event.non_compliance.question.tag_ids': 'etiqueta de la pregunta',
  'fields.non_compliance_event.type': 'tipo',
  'fields.non_compliance_event.form_reply.form_id': 'formulario',
  'fields.form_reply_id': 'respuesta de formulario',

  'fields.place_lock.checklist_id': 'cuestionario',
  'fields.place_unlock.checklist_id': 'cuestionario',

  'fields.forms_non_compliance_event.non_compliance.place_id': 'Local de la no conformidad',
  'fields.forms_non_compliance_event.reply.question.checklist_id': 'Cuestionario del formulario guardado',
  'fields.forms_non_compliance_event.non_compliance.question.name': 'Pregunta que generó la no conformidad',
  'fields.forms_non_compliance_event.non_compliance.place.resume': 'Nombre completo del destino',
  'fields.forms_non_compliance_event.non_compliance.place.name': 'Nombre del destino',

  'entities.undefined': '___',
  'entities.service_order': 'actividad',
  'entities.reply': 'respuesta',
  'entities.event': 'evento',
  'entities.checklist': 'cuestionario',
  'entities.place': 'local',
  'entities.person': 'persona',
  'entities.fleet': 'flota',
  'entities.user': 'usuario',
  'entities.non_compliance': 'agrupación de no conformidad',
  'entities.non_compliance_event': 'evento de una no conformidad',
  'entities.forms_non_compliance_event': 'evento de una no conformidad',
  'entities.form': 'formulario',
  'entities.form_reply': 'respuesta de formulario',

  'events.undefined': '___',

  'events.save': 'creado o actualizado',
  'events.save_female': 'creada o actualizada',
  'events.insert': 'creado',
  'events.insert_female': 'creada',
  'events.upsert': 'creado o actualizado',
  'events.upsert_female': 'creada o actualizada',
  'events.update': 'actualizado',
  'events.update_female': 'actualizada',
  'events.delete': 'eliminado',
  'events.delete_female': 'eliminada',
  'events.reply': 'respondida',

  'events.relative_before': 'antes de la ',
  'events.moment': 'En el momento exacto de la ',
  'events.relative_after': 'después de la ',

  'actions.undefined': '___',
  'actions.insert_service_order': 'crear una nueva actividad',
  'actions.insert_service_orders': 'crear varias actividades',
  'actions.complete_service_orders': 'completar las actividades abiertas',
  'actions.complete_non_compliances': 'completar las no conformidades abiertas',
  'actions.schedule_insert_service_order': 'crear una nueva actividad en el futuro',
  'actions.schedule_insert_service_orders': 'crear varias actividades en el futuro',
  'actions.update_service_order_name': 'actualizar nombre de la actividad',
  'actions.insert_user': 'crear un nuevo usuario',
  'actions.insert_place': 'crear un nuevo local/persona',
  'actions.webhook': 'llamar a la api externa',
  'actions.email': 'enviar un email',
  'actions.createNonCompliance': 'crear no conformidad',
  'actions.action': 'acción',
  'actions.update_service_order_user_or_group': 'actualizar usuario o grupo de la actividad',

  'actions.slack_channel_message': 'enviar un mensaje en slack',
  'actions.slack_direct_message': 'enviar un DM vía slack',
  'actions.google_calendar_insert_event': 'crear un evento en el calendario',
  'actions.d4sign_send_to_sing': 'enviar un documento',
  'actions.d4sign_attach_document': 'adjuntar un documento',
  'actions.d4sign_gen_pdf_and_send_to_sing': 'generar PDF y enviar',
  'actions.whatsapp_by_twilio': 'enviar un Whatsapp vía Twilio',
  'actions.whatsapp_by_chat_pro': 'enviar un Whatsapp vía ChatPro',
  'chatPro.dynamicNumber': 'dinámico',
  'actions.sms_by_twilio': 'enviar un SMS vía Twilio',

  'actions.place_lock': 'Desactivar apertura de actividad para el local de la no conformidad usando el cuestionario',
  'actions.set_availability_status': 'Alterar Estado de Disponibilidad del Lugar',
  'actions.update_place': 'actualizar local de la actividad',
  'actions.update_asset': 'actualizar local del activo',

  'actions.update_status': 'actualizar estado de la actividad',
  'actions.assign_tag': 'asignar una tag a la actividad',
  'actions.remove_tag': 'eliminar la tag de la actividad',
  'actions.update_parent_status': 'actualizar estado de la actividad padre',
  'actions.update_child_service_order': 'Actualizar Actividad',

  'replyTypes.undefined': '___',
  'replyTypes.nonCompliance': 'no conformidad',
  'replyTypes.text': 'texto',
  'replyTypes.number': 'número',

  'webhook.addNew': 'Agregar nueva Header',
  'webhook.authorization': 'autorización',
  'webhook.workspace': 'workspace',

  'webhook.key': 'Clave',
  'webhook.value': 'Valor',

  name: 'Nombre',
  readOnly: 'Solo lectura',
  enabled: 'Activado',
  quantity: 'Cantidad',
  title: 'Automatizaciones',
  new: 'Nueva Automatización',
  bulkRegistration: 'Registro en masa',
  serviceOrdersCount: '{{count}} actividad',
  serviceOrdersCount_plural: '{{count}} actividades',
  dynamicFields: 'campos dinámicos',
  content: 'Contenido',
  'fields.name': 'Nombre',
  'fields.email': 'Email',
  'fields.profile': 'Perfil',
  'fields.checklist': 'Cuestionario*',
  'fields.destinationType': 'Tipo de destino',
  'fields.destination': 'Destino*',
  'fields.asset': 'Activo',
  'fields.responsible': 'Responsable',
  'fields.scheduling': 'Programación',
  'fields.bond': 'Vínculo',
  'fields.type': 'Tipo',
  'fields.description': 'Descripción',
  'fields.metadata': 'Metadata',
  'fields.placePerson': 'Local/Persona*',
  'fields.schedulingDate': 'Fecha de programación',
  'fields.user': 'Usuario',
  updatePlaceData: 'Actualizar datos de local',
  fieldsWithoutValueNotChanged: 'Los campos sin valor no serán modificados.',
  addPlaceTypeCondition:
    'Para cambiar los campos adicionales, agregue la condición de tipo de local en la automatización.',
  fillAtLeastOneField: 'Complete al menos un campo.',
  'googleCalendar.eventTitle': 'Título del evento',
  'googleCalendar.description': 'Descripción',
  'googleCalendar.startsAt': 'Inicia en',
  'googleCalendar.duration': 'Duración del evento',
  'googleCalendar.durationOptions.15': 'Quince minutos',
  'googleCalendar.durationOptions.30': 'Media hora',
  'googleCalendar.durationOptions.60': 'Una hora',
  'googleCalendar.durationOptions.90': 'Una hora y media',
  'googleCalendar.durationOptions.120': 'Dos horas',
  'googleCalendar.durationOptions.150': 'Dos horas y media',
  'googleCalendar.durationOptions.180': 'Tres horas',
  'googleCalendar.durationOptions.210': 'Tres horas y media',
  'googleCalendar.durationOptions.240': 'Cuatro horas',
  'googleCalendar.emailReminder': 'Recordatorio por email antes del evento (en minutos)',
  'd4sign.signers': 'firmantes',
  'd4sign.signersRequired': 'Firmantes*',
  'd4sign.documentName': 'Nombre del documento',
  'd4sign.safe': 'Caja fuerte*',
  'd4sign.folderOptional': 'Carpeta (opcional)',
  'd4sign.document': 'Documento*',
  'd4sign.configureSigners': '+ Configurar Firmantes',
  'd4sign.sequentialSignature': 'Usar firma en secuencia (opcional)',
  'd4sign.emailRequired': 'Email*',
  'd4sign.actionRequired': 'Acción*',
  'd4sign.configureDocumentSending': 'Configurar envío de documentos',
  'd4sign.publicTokenForWebhook': 'Token público para webhook',
  'actions.originActivity': 'actividad origen',
  minimumOneRecord: 'Mínimo de 1 registro',
  selectAtLeastOneLevel: 'Seleccione al menos un nivel',
  invalidPayload: 'Payload inválido',
  triggerCannotBeEdited: 'El gatillo no puede ser editado',
  'templates.onCompleteActivitySendEmail': 'Al concluir una actividad, envía un email',
  'templates.onCompleteActivityCallExternalApi': 'Al concluir una actividad, llama a una api externa',
  'templates.onCompleteActivitySendSlackMessage': 'Al concluir una actividad, envía un mensaje en slack',
  'templates.onCompleteActivitySendDocumentToSign': 'Al concluir una actividad, envía un documento para ser firmado',
  'templates.onCompleteActivityAttachDocument': 'Al concluir una actividad, adjunta un documento al origen',
  'templates.onCompleteActivitySendWhatsappTwilio': 'Al concluir una actividad, envía un whatsapp vía twilio',
  'templates.onCompleteActivitySendSmsTwilio': 'Al concluir una actividad, envía un sms vía twilio',
  'templates.onCompleteActivitySendWhatsappChatPro': 'Al concluir una actividad, envía un whatsapp vía ChatPro',
  'templates.onCreateActivityCreateGoogleCalendarEvent': 'Al crear una actividad, crea un evento en google calendar',
  'templates.onCompleteActivityCreateNewActivity': 'Al concluir una actividad, crea una nueva actividad',
  'templates.onCreateActivityCreateAnotherActivity': 'Al crear una actividad, crea otra actividad',
  'templates.onCreateUserSendEmail': 'Al crear un usuario, envía un email',
  'templates.onCreateUserCallExternalApi': 'Al crear un usuario, llama a una api externa',
  'templates.onCreateUserCreateActivity': 'Al crear un usuario, crea una actividad',
  'templates.onReplyFormSendEmail': 'Al responder un formulario, envía un email',
  'templates.onReplyFormCallExternalApi': 'Al responder un formulario, llama a una api externa',
  'templates.onReplyFormCreateActivity': 'Al responder un formulario, crea una actividad',
  'templates.onCreateNonComplianceInstanceSendEmail':
    'Al crear una nueva ocurrencia de una no conformidad, envía un email',
  'templates.onCreateNonComplianceInstanceCallExternalApi':
    'Al crear una nueva ocurrencia de una no conformidad, llama a una api externa',
  'templates.onCreateNonComplianceInstanceCreateActivity':
    'Al crear una nueva ocurrencia de una no conformidad, crea una actividad',
  'templates.onCreateFormsNonComplianceInstanceSendEmail':
    'Al crear una nueva ocurrencia de una no conformidad, envía un email',
  'templates.onCreateFormsNonComplianceInstanceCallExternalApi':
    'Al crear una nueva ocurrencia de una no conformidad, llama a una api externa',
  'templates.onCreateFormsNonComplianceInstanceCreateActivity':
    'Al crear una nueva ocurrencia de una no conformidad, crea una actividad',
  'templates.onCreatePlaceTypeSendEmail': 'Al crear un(a) {{placeType}}, envía un email',
  'templates.onCreatePlaceTypeCallExternalApi': 'Al crear un(a) {{placeType}}, llama a una api externa',
  'templates.onCreatePlaceTypeCreateActivity': 'Al crear un(a) {{placeType}}, crea una actividad',
  'templates.createCustomAutomation': 'Crear una automatización personalizada',
  'templates.createNew': 'Crear nueva',
  'templates.useTemplate': 'Usar plantilla',
  'baseSentence.whenActivityCreated': 'Cuando una actividad sea creada',
  'baseSentence.whenActivityUpdated': 'Cuando una actividad sea actualizada',
  'baseSentence.whenActivityCreatedOrUpdated': 'Cuando una actividad sea creada o actualizada',
  'baseSentence.whenActivityStatusChanged': 'Cuando una actividad cambie de estado',
  'baseSentence.whenActivityTagAssigned': 'Cuando una actividad reciba una tag',
  'baseSentence.whenActivityTagRemoved': 'Cuando una actividad pierda la tag',
  'baseSentence.whenNonComplianceEventCreated': 'cuando un evento de no conformidad sea creado',
  'baseSentence.whenNonComplianceGroupCreated': 'cuando un agrupamiento de no conformidad sea creado',
  'baseSentence.whenFormReplied': 'cuando un formulario sea respondido',
  'baseSentence.whenReplyEdited': 'Cuando una respuesta sea editada',
  'baseSentence.whenPlaceTypeCreated': 'Cuando un(a) {{placeType}} sea creado',
  'baseSentence.whenPlaceTypeUpdated': 'Cuando un(a) {{placeType}} sea actualizado',
  'baseSentence.whenPlaceTypeCreatedOrUpdated': 'Cuando un(a) {{placeType}} sea creado o actualizado',
  'completeServiceOrders.moreThanDays': 'hace más de {{days}} días; ',
  'completeServiceOrders.withChecklists': ' con cuestionarios {{checklists}}; ',
  'completeServiceOrders.shouldFireAutomations': 'Debe disparar automatizaciones.',
  'completeServiceOrders.configureAutomationBehavior': 'Configure el comportamiento de esta automatización.',
  'completeServiceOrders.moreThanDaysLabel': 'hace más de (en días)',
  'completeServiceOrders.fireAutomations': 'Disparar automatizaciones.',
  'completeNonCompliances.moreThan': 'hace más de ',
  'completeNonCompliances.days': 'días',
  'updateStatus.to': 'a ',
  'assignTag.to': 'con la tag ',
  'assignTag.tag': 'Tag',
  'updateStatus.status': 'Estado',
  'updateServiceOrderUserOrGroup.user': 'usuario: {{name}}',
  'updateServiceOrderUserOrGroup.group': 'grupo: {{name}}',
  'updateServiceOrderUserOrGroup.groups': 'grupos',
  'updateServiceOrderUserOrGroup.withThe': 'con el',
  'updateServiceOrderUserOrGroup.withTheGroups': 'con los',
  'typeSelect.actionPlan': 'Plan de acción',
  'typeSelect.activity': 'Actividad',
  'fieldsSection.additionalFields': 'Campos adicionales',
  'fieldsSection.addFile': 'Agregar Archivo',
  'lockPlace.disablePlaceForNonCompliance': 'Desactivar destino para no conformidad',
  'lockPlace.reasonRequired': 'Motivo*',
  'insertPlace.typeRequired': 'Tipo*',

  actionNotAllowedForTrigger: 'Esta acción no está disponible para este disparador',
  'updateChildServiceOrder.nothingToChange': 'Seleccione al menos un dato para actualizar en la actividad',
  'updateChildServiceOrder.actionLabel.current': 'Actualizar Actividad actual',
  'updateChildServiceOrder.actionLabel.child': 'Actualizar Actividad Hija',
  'updateChildServiceOrder.target': 'Qué actividad actualizar',
  'updateChildServiceOrder.target.current': 'Actividad actual (la que disparó la automatización)',
  'updateChildServiceOrder.target.child': 'Actividad hija vinculada',
  'updateChildServiceOrder.targetHelp.current':
    'Se actualiza la propia actividad que disparó la automatización (no se crea ninguna actividad nueva). Si alguien la tiene abierta en pantalla, lo que se guarde después puede sobrescribir el cambio hecho por la automatización.',
  'updateChildServiceOrder.targetHelp.child':
    'Se actualiza la actividad hija vinculada a la actividad que disparó la automatización.',
  'updateChildServiceOrder.status': 'Estado',
  'updateChildServiceOrder.fieldsHelpCurrent':
    'Solo se actualizan en la actividad los campos adicionales completados aquí. Sus demás campos adicionales se mantienen como están.',
  'updateChildServiceOrder.documentsHelpCurrent':
    'Los documentos elegidos se agregan a la actividad. Los documentos que ya tiene se mantienen.',
  'updateChildServiceOrder.with': 'con los datos ',
  'updateChildServiceOrder.description': 'Descripción',
  'updateChildServiceOrder.place': 'Local',
  'updateChildServiceOrder.scheduling': 'Fecha de agendamiento',
  'updateChildServiceOrder.checklists': 'Qué actividades hijas actualizar',
  'updateChildServiceOrder.checklistsHelp':
    'Se aplica a la actividad hija vinculada al cuestionario elegido. Si la actividad tiene solo una actividad hija vinculada, este campo puede quedar en blanco (se usa automáticamente); solo es necesario cuando hay más de una.',
  'updateChildServiceOrder.name': 'Nombre',
  'updateChildServiceOrder.user': 'Responsable',
  'updateChildServiceOrder.asset': 'Activo',
  'updateChildServiceOrder.priority': 'Prioridad',
  'updateChildServiceOrder.address': 'Dirección',
  'updateChildServiceOrder.metadata': 'Metadata',
  'updateChildServiceOrder.tag': 'Tag',
  'updateChildServiceOrder.documents': 'Documentos',
  'updateChildServiceOrder.documentsHelp':
    'Los documentos elegidos se agregan a la actividad hija. Los documentos que ya tiene se mantienen.',
  'updateChildServiceOrder.fieldsHelp':
    'Solo se actualizan en la actividad hija los campos adicionales completados aquí. Sus demás campos adicionales se mantienen como están.',
  'updateChildServiceOrder.dependentHelp':
    'Solo se actualizan las actividades hijas vinculadas a la actividad padre como dependientes (la actividad padre queda pendiente hasta que la hija se complete).'
}
